var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalleryBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 321,
    height: 305,
    viewBox: "0 0 321 305",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.148 303.96C252.197 313.401 197.354 256.55 147.539 213.826C101.359 174.218 66.864 125.498 43.5556 69.3076C18.4187 8.70933 -16.9853 -59.4546 9.23283 -119.593C35.2676 -179.311 114.578 -187.891 170.361 -221.557C219.818 -251.405 259.82 -312.554 317.148 -305.427C374.664 -298.277 394.661 -224.668 439.61 -188.085C480.746 -154.605 537.213 -144.17 568.183 -101.116C607.412 -46.5805 661.202 21.817 635.133 83.7285C608.618 146.697 510.522 130.324 454.348 169.23C400.33 206.641 382.176 294.508 317.148 303.96Z",
    fill: "#FFF6D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryBackground);
export default __webpack_public_path__ + "static/media/gallery-background.09c45c874e8c9615464b8cf4ab6dc8d2.svg";
export { ForwardRef as ReactComponent };